/**
 * BUG-2620: a dine-in table order, judged from the order itself. HMRS/11406 (H4, Dine-In) was
 * saved with the screen's dineIn flag "N", so the table cleanup after payment never ran and H4
 * stayed "Order Placed". Every order carries a tableId, so the Dine-In sale type decides.
 */
export const isDineInTableOrder = (order) => !!order?.tableId && order?.saleType?.fulfilmentType === "DI";
